<template>
    <v-container fluid>

        <v-row>
            <v-col>
                <h4 class="text-h4"> Good Issue #{{form.number_f}}</h4>
                <p class="text-subtitle"> Good Issue Display </p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <div v-if="form.lines">
        <v-row>
            <v-col cols="12" md="3"> 
                <v-btn block outlined @click="handleSimulate">
                    <v-icon left >mdi-form-select</v-icon>
                    Simulate
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-btn block :disabled="updateMode">
                    <v-icon>mdi-pencil</v-icon>
                    Edit
                </v-btn>
            </v-col>
        </v-row>
        <v-row >
            <v-col>
                <v-row >
                    <v-col>
                        <v-simple-table dense>
                            <tbody>
                                <tr>
                                    <th>Date</th>
                                    <td>{{form.date}}</td>
                                </tr>
                                <tr>
                                    <th>Document Date</th>
                                    <td>{{form.document_date}}</td>
                                </tr>
                                <tr>
                                    <th>Code</th>
                                    <td>{{form.number_f}}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                    <v-col>
                        <v-simple-table dense>
                            <tbody>
                                <tr>
                                    <th>State</th>
                                    <td>
                                        <PStatus :state="form.state "/>
                                    </td>
                                </tr>
                                <tr>
                                    <th>Warehouse</th>
                                    <td>{{form.lines[0].warehouse.name}}</td>
                                </tr>
                                <tr>
                                    <th>Reference</th>
                                    <td>{{form.reference}}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-simple-table dense>
                            <thead>
                                <tr>
                                    <th>Item</th>
                                    <th>Quantity</th>
                                    <th>Account</th>
                                    <th>Warehouse</th>
                                    <th>Dimension</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="line in form.lines" :key="line.key">
                                    <td>{{line.item.display_name}}</td>
                                    <td>{{`${line.quantity} ${line.measure_unit.abbreviation}` }}</td>
                                    <td>{{line.account.display_name}}</td>
                                    <td>{{line.warehouse.display_name}}</td>
                                    <td>{{line.dimension.name}}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-simple-table dense>
                            <tbody>
                                <tr>
                                    <th>Remarks</th>
                                    <td>{{form.remarks}}</td>
                                </tr>
                                <tr>
                                    <th>Journal Remarks</th>
                                    <td>{{form.journal_remarks}}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        </div>
        <div v-else class="d-flex justify-center align-center pa-3">
            <v-icon class="mx-2" large>mdi-alert-decagram-outline</v-icon>
            <h1 class="text-h4">No Data Available</h1>
        </div>
        <LoadingOverlay v-model="loading"/>
        <simulate-entries
            v-if="simulateEntryShown"
            v-model="simulateEntryShown"
            :entry="simulatedEntry"
            :is-posted="isPosted"
            :can-post="canPost"
            @post="post"
            >
        </simulate-entries>
    </v-container>
</template>

<script>
import { clone } from 'lodash';
import { getStockJournalByNumber, getIdempotentKey, postStockJournal } from './../../services/stockJournal';
import SimulateEntries from './../../components/accounting/SimulateEntries';
import PStatus from '../../components/common/PStatus'
import LoadingOverlay from '@/components/common/LoadingOverlay'
import { mapActions } from 'vuex';
export default {
    name: "GoodIssueDisplayView",
    components: {
        LoadingOverlay,
        PStatus,
        SimulateEntries
    },
    data() {
        return {
            loading: false,
            form: {},
            simulateEntryShown: false,
            requestId: null
        }
    },
    computed: {
        canPost() {
            if(this.form.can) {
                return this.form.can.post;
            }
            return false;
        },
        isPosted() {
            return this.form.state == 'POSTED';
        },
        updateMode() {
            return !this.form.can.update;
        }
    },
    methods: {
        ...mapActions({
            snackbar: "ui/snackbar/show"
        }),
        async fetchGoodIssue({number}) {
            try {
                this.loading = true;
                let resp = await getStockJournalByNumber({number, type: "GOODS_ISSUE"});
                this.form = resp.data;
                this.loading = false;
            } catch (error) {
                this.loading = false;
                let message = error.response ? error.response.data.message : error
                console.log(message)
                this.snackbar({color: 'error', text: message })
            }
        },
        handleSimulate() {
            this.simulatedEntry = this.form.ledger_transaction;
            this.simulateEntryShown = true;
        },
        async post() {
            try {
                this.loading = true;
                if(!this.requestId) await this.fetchIdempotentKey();
                let resp = await postStockJournal(this.form.id, this.requestId);
                this.form = clone(resp.data.record, true);
                this.snackbar({color: "success", text: resp.data.message });
                this.loading = false;
            } catch (error) {
                this.loading = false;
                let message = error.response ? error.response.data.message : error;
                this.snackbar({color: "error", text: message });
            }
        },
        async fetchIdempotentKey() {
            this.loading = true;
            let response = await getIdempotentKey();
            this.requestId = response.data.key;
            this.loading = false;
        },
    },
    created() {
        this.fetchGoodIssue({ number: this.$route.params.id })
    }
}
</script>

<style>

</style>